import makeStyles from '@mui/styles/makeStyles';
import type { Theme } from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => ({
  rootStepper: {
    display: 'grid',
    gridGap: '1rem',
    gridTemplateColumns: 'repeat(2,1fr)',
    height: '100%',
    [theme.breakpoints.down('md')]: {
      display: 'inline',
    },
  },
  rootSectionSteps: {
    backgroundColor: theme.palette.primary.main,
    [theme.breakpoints.down('md')]: {
      position: 'sticky',
      top: 0,
      'z-index': 2,
    },
  },
  rootSectionStepsWhite: {
    backgroundColor: theme.palette.grey[100],
    color: theme.palette.primary.main,
  },
  rootSectionStepsBlack: {
    backgroundColor: theme.palette.primary.main,
    color: '#FFFFFF',
  },
  rootSectionInteraction: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    [theme.breakpoints.down('md')]: {
      height: 'calc(100vh - 182px)',
    },
  },
  wrapperSectionSteps: {
    bottom: '0',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    left: '0',
    padding: '2rem',
    position: 'fixed',
    top: '0',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'row',
      position: 'relative',
      paddingTop: '1rem',
    },
  },
  contentSteps: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'space-between',
    [theme.breakpoints.down('md')]: {
      height: 'auto',
      justifyContent: 'initial',
      width: '100%',
    },
  },
  headerContentSteps: {
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      justifyContent: 'space-between',
      paddingBottom: '1rem',
      alignItems: 'center',
    },
  },
  contentBodySteps: {
    margin: '0px auto 0px 0px',
    maxWidth: '28rem',
    boxSizing: 'content-box',
    width: '100%',
    padding: '1rem 1rem 1rem 4.5rem',
    [theme.breakpoints.down('md')]: {
      margin: '0 auto',
      padding: 0,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  contentLinearProgress: {
    alignItems: 'center',
    display: 'flex',
    marginBottom: '2rem',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      justifyContent: 'center',
      marginBottom: '1rem',
    },
  },
  stepperTitle: {
    fontSize: '2.5rem',
    lineHeight: '3.5rem',
    fontWeight: 500,
    marginBottom: '1rem',
    [theme.breakpoints.down('md')]: {
      fontSize: theme.typography.pxToRem(20),
      marginBottom: '0.5rem',
    },
  },
  stepperDescription: {
    fontSize: '1.5rem',
    fontWeight: 400,
    [theme.breakpoints.down('md')]: {
      fontSize: theme.typography.pxToRem(14),
    },
  },
  boxReference: {
    alignItems: 'center',
    color: theme.palette.darkGrey.main,
    background: theme.palette.darkGrey[2],
    border: `1px dashed ${theme.palette.darkGrey[50]}`,
    borderRadius: theme.typography.pxToRem(4),
    display: 'flex',
    fontWeight: 500,
    fontSize: theme.typography.pxToRem(24),
    padding: theme.typography.pxToRem(12),
  },

  stateLoadingTokenizer: {
    width: '100%',
    height: '450px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },

  stateErrorTokenizer: {
    fontSize: '1.15rem',
    width: '280px',
    marginTop: theme.spacing(4),
    textAlign: 'center',
  },

  notificationTokenizer: {
    background: theme.palette.darkGrey[5],
    borderRadius: theme.shape.borderRadius,
    color: theme.palette.darkGrey.main,
    padding: '1rem',
    fontSize: theme.typography.pxToRem(14),
  },

  wrapperEndContent: {
    width: '100%',
    margin: '0px auto',
    paddingInline: '5rem',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: '1rem',
    justifyContent: 'center',
    [theme.breakpoints.down('md')]: {
      alignItems: 'center',
      paddingTop: 24,
      paddingInline: '0px',
      justifyContent: 'initial',
    },
    [theme.breakpoints.down('sm')]: {
      paddingInline: '0px',
    },
  },

  addressTitle: {
    fontSize: theme.typography.pxToRem(18),
    fontWeight: 500,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },

  wrapBase: {
    display: 'flex',
    flexDirection: 'row',
    gap: 24,
    paddingBottom: 24,
    alignItems: 'flex-end',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },

  inputsName: {
    width: '100%',
    maxWidth: 267,
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%',
    },
  },
  inputBaseSpreddly: {
    width: '100%',
    height: '42px',
    marginTop: theme.spacing(0.5),
  },
  inputsExpirationDate: {
    width: 127,
    [theme.breakpoints.down('md')]: {
      width: '50%',
    },
  },
  customLabel: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    transform: 'translate(0, 1.5px) scale(1)',
    transformOrigin: 'top left',
  },
  customLabelError: {
    color: theme.palette.error.main,
  },
  titleSection: {
    fontSize: 18,
    fontWeight: 500,
    padding: '24px 0',
    [theme.breakpoints.down('md')]: {
      fontSize: 16,
    },
  },
  messageErrorValidation: {
    color: theme.palette.error.main,
    fontSize: theme.typography.pxToRem(12),
    marginTop: '3px',
  },
  customButtonCheckout: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 16,
    borderRadius: 4,
    background: '#000',
  },
  wrapperContentButton: {
    marginTop: theme.spacing(2),
    width: '100%',
    '& > button': {
      maxWidth: 212,
      width: '100%',
      marginBottom: 24,
    },
    [theme.breakpoints.down('md')]: {
      '& > button': {
        maxWidth: 300,
        marginBottom: 24,
      },
      backgroundColor: theme.palette.background.default,
      display: 'flex',
      justifyContent: 'center',
      marginTop: 0,
      paddingTop: '1.5rem',
      paddingInline: 24,
      position: 'fixed',
      bottom: 0,
      left: 0,
    },
    [theme.breakpoints.down('sm')]: {
      '& > button': {
        maxWidth: '100%',
      },
    },
  },
  contetOptionsPaymentMethods: {
    marginBottom: theme.spacing(4),
    height: 'auto',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'center',
      marginBottom: theme.spacing(2),
      height: 'calc(100% - 100px)',
    },
  },
  contentFormDataCustomer: {
    width: '100%',
    height: 'auto',
    justifyContent: 'center',
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down('md')]: {
      marginBottom: 0,
      height: 'calc(100% - 100px)',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
    },
  },
  wrapperBodyForm: {
    overflow: 'hidden',
    [theme.breakpoints.down('md')]: {
      overflowY: 'auto',
      height: '100%',
      paddingInline: '5rem',
    },
    [theme.breakpoints.down('sm')]: {
      paddingInline: '2rem',
    },
  },
  wrapperSpreddlyCheckout: {
    margin: '0px auto',
    maxWidth: 588,
    width: '100%',
    overflow: 'hidden',
    [theme.breakpoints.down('md')]: {
      overflowY: 'auto',
      height: '100%',
      margin: 0,
      maxWidth: '100%',
      paddingInline: '5rem',
    },
    [theme.breakpoints.down('sm')]: {
      paddingInline: '2rem',
    },
  },
  inputNumberStyle: {
    '&>input::-webkit-outer-spin-button, input::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },

    '&>input[type=number]': {
      '-moz-appearance': 'textfield',
    },
  },
}));

export default useStyles;
